import React, { useState, useEffect } from 'react';
import FeedbackForm from './feedbackForm';
import SuccessPage from './success';
import { useSaga } from 'use-reducer-saga';
import reducer, { initialState } from '../localStore/reducer';
import sagas from '../localStore/sagas';
import { sendFeedbackStart } from '../localStore/actions';

const FeedbackPanel: React.FC<Props> = ({ onClose }) => {
  const [localStore, localDispatch] = useSaga(reducer, initialState, sagas);
  const { feedback, isSendingFeedback = false, feedbackError } = localStore;
  const [successSendFeedback, setSuccessSendFeedback] =
    useState<boolean>(false);

  const handleSubmit = (val: any) => {
    const data = {
      label: val.feedbackType,
      subject: val.subject,
      body: val.description
    };
    localDispatch(sendFeedbackStart(data));
  };

  useEffect(() => {
    if (!isSendingFeedback && feedback) {
      setSuccessSendFeedback(true);
    }
  }, [isSendingFeedback, feedback, feedbackError]);

  return (
    <div className="feedback --swx-theme--dark">
      {!successSendFeedback && (
        <FeedbackForm
          onSubmit={handleSubmit}
          handleCancel={onClose}
          isSendingFeedback={isSendingFeedback}
        />
      )}
      {successSendFeedback && <SuccessPage handleCancel={onClose} />}
    </div>
  );
};

type Props = {
  onOpenpanel?: Function;
  onClose: Function;
};

export default React.memo(FeedbackPanel);
